import React, { lazy } from 'react';
import { Section } from '../ui/Section';
import { Check } from 'lucide-react';
export function ProductOverview() {
  const features = ['Planilla de Seguimiento de Pacientes', 'Sistema de Semáforo para Autorizaciones', 'Plantillas de Historia Clínica', 'Guiones de Comunicación de Diagnóstico', 'Tablero Financiero del Consultorio', 'Dashboard de Indicadores de Gestión', 'Sistema de Prevención de Burnout', 'Protocolo de Bienvenida al Paciente'];
  const categories = ['Seguimiento de Pacientes', 'Autorizaciones', 'Documentación Clínica', 'Comunicación', 'Gestión Financiera', 'Indicadores de Gestión', 'Prevención de Burnout', 'Onboarding de Pacientes'];
  return <Section className="bg-slate-50" data-id="element-211">
      <div className="container mx-auto px-4" data-id="element-212">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16" data-id="element-213">
          <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-4 md:mb-6" data-id="element-214">
            SISTEMA DE GESTIÓN PARA CONSULTORIO ONCOLÓGICO
          </h2>
          <p className="text-lg md:text-xl text-teal-700 font-semibold mb-4" data-id="element-215">
            Sistema completo · 8 Tomos + 3 Bonos · Para oncólogos independientes
            · Todo resuelto.
          </p>
          <div className="flex justify-center gap-3 md:gap-4 text-xs md:text-sm font-bold text-slate-500" data-id="element-216">
            <span className="bg-white px-3 py-1.5 md:px-4 md:py-2 rounded-full shadow-sm border border-slate-200" data-id="element-217">
              +80 pág.
            </span>
            <span className="bg-white px-3 py-1.5 md:px-4 md:py-2 rounded-full shadow-sm border border-slate-200" data-id="element-218">
              11 plantillas
            </span>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center max-w-5xl mx-auto" data-id="element-219">
          <div className="order-2 lg:order-1" data-id="element-220">
            <h3 className="text-xl md:text-2xl font-bold text-slate-900 mb-4 md:mb-6" data-id="element-221">
              Funciona desde hoy en tu consultorio, sin software adicional.
            </h3>

            <div className="mb-6 md:mb-8" data-id="element-222">
              <h4 className="font-bold text-slate-700 mb-3 md:mb-4 uppercase tracking-wider text-xs md:text-sm" data-id="element-223">
                Áreas cubiertas:
              </h4>
              <div className="flex flex-wrap gap-1.5 md:gap-2" data-id="element-224">
                {categories.map((cat, i) => <span key={i} className="bg-teal-50 text-teal-700 px-2 py-1 md:px-3 md:py-1 rounded-md text-xs md:text-sm font-medium border border-teal-100 hover:bg-teal-100 transition-colors cursor-default" data-id="element-225">
                    {cat}
                  </span>)}
              </div>
            </div>

            <div data-id="element-226">
              <h4 className="font-bold text-slate-700 mb-3 md:mb-4 uppercase tracking-wider text-xs md:text-sm" data-id="element-227">
                Herramientas incluidas:
              </h4>
              <ul className="space-y-2 md:space-y-3" data-id="element-228">
                {features.map((feature, i) => <li key={i} className="flex items-start gap-2 md:gap-3 group" data-id="element-229">
                    <div className="mt-0.5 md:mt-1 bg-teal-100 rounded-full p-0.5 group-hover:bg-teal-200 transition-colors" data-id="element-230">
                      <Check className="h-3 w-3 md:h-4 md:w-4 text-teal-600" data-id="element-231" />
                    </div>
                    <span className="text-sm md:text-base text-slate-700 font-medium" data-id="element-232">
                      {feature}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="order-1 lg:order-2" data-id="element-233">
            <img src="https://cdn.magicpatterns.com/uploads/teLSGh4uq6698nQ2eb4oy1/MOCKUP_TRANSPARENTE_ONCOLOGO.png" alt="Mockup del Megapack" loading="lazy" decoding="async" width={1024} height={1024} className="w-full max-w-sm mx-auto lg:max-w-full h-auto drop-shadow-xl hover:scale-105 transition-transform duration-500" data-id="element-234" />
          </div>
        </div>
      </div>
    </Section>;
}